function CalendarOutline({width = 18, height = 18}: {width?: number; height?: number}) {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
            <path
                d="M6 1.4994V4.49964M12 1.4994V4.49964M2.25 7.49988H15.75M3.75 2.99952H14.25C15.0784 2.99952 15.75 3.67115 15.75 4.49964V15.0005C15.75 15.829 15.0784 16.5006 14.25 16.5006H3.75C2.92157 16.5006 2.25 15.829 2.25 15.0005V4.49964C2.25 3.67115 2.92157 2.99952 3.75 2.99952Z"
                stroke="currentColor"
                strokeLinecap="round"
            />
        </svg>
    );
}

export default CalendarOutline;
